import yesNoModel from './yesNoModel';
import riskLevelModel from './riskLevelModel';

const aditionalInformationModel = () => {
  return {
    sections: [
      {
        title: 'Additional Information',
        rows: [
          {
            cols: [
              {
                label: 'Check the highest form of education completed',
                mapTo: 'educationId',
                required: false,
                type: 'radio',
                optionType: 'HeighesEducation',
                inline: true,
                includeOther: true,
                otherMapTo: 'educationOther',
                maxLength: 300
              },
            ],
          },
        ],
      },
      {
        title: 'Sexual Orientation',
        style: {
          marginTop: '15px',
        },
        rows: [
          {
            cols: [              
              {
                label: 'Gender Identity',
                mapTo: 'genderId',
                validation: undefined,
                required: false,
                optionType: 'Gender',
                type: 'select',
                isInvalid: false,
                style: {
                  width: '109px',
                },
              }
            ]
          },
          {
            cols: [
              {
                label: 'LGBTQIA+ - Community Member',
                mapTo: 'IdentifyAsMemberLGBTQIAplusId',
                optionType: 'IdentifyAsLGBTQIAPlus',
                type: 'radio',
                inline: true,
              },
            ],
          },
          {
            cols: [
              {
                label: 'Sexual Orientation',
                mapTo: 'sexualIdentityId',
                type: 'radio',
                optionType: 'SexualIdentity',
                includeOther: false,
                maxLength: 300,
                inline: true
              },
            ],
          }
        ]
      },
      {
        style: {
          marginTop: '15px',
        },
        rows: [
          {
            cols: [
              {
                label: 'Does this individual have any work experience?',
                mapTo: 'hasWorkExperience',
                options: yesNoModel().yesNo,
                type: 'radio',
                inline: true,
              },
            ],
          },
          {
            cols: [
              {
                label:
                  'If yes, list the last three jobs, beginning with the current or most recent job.',
                type: 'label',
              },
            ],
          },
          {
            cols: [
              {
                label: 'Employer/Business Name',
                type: 'text',
                mapTo: 'jobs[0].businessName',
                maxLength: 50,
              },
              {
                label: 'Job Title',
                type: 'text',
                mapTo: 'jobs[0].jobTitle',
              },
            ],
          },
          {
            cols: [
              {
                label: 'Start Date',
                mapTo: 'jobs[0].startDate',
                type: 'date',
              },
              {
                label: 'End Date',
                mapTo: 'jobs[0].endDate',
                type: 'date',
              },
              {
                label: '# of hrs. worked per week',
                mapTo: 'jobs[0].hoursByWeek',
                type: 'number',
                min: '0',
                max: '336',
                isInteger: true
              },
              {
                label: 'Rate of Pay',
                type: 'number',
                mapTo: 'jobs[0].rateOfPay',
                min: '0.00',
                max: '100000',
                isDecimal: true
              },
            ],
          },
          {
            cols: [
              {
                label: 'Job Responsibilities',
                type: 'textarea',
                mapTo: 'jobs[0].jobResponsibilities',
                style: {
                  width: '434px',
                },
              },
              {
                label: 'Why did you leave?',
                type: 'textarea',
                mapTo: 'jobs[0].leaveReason',
                style: {
                  width: '434px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'jobs[0].address',
                type: 'text',
              },
              {
                label: 'City',
                mapTo: 'jobs[0].city',
                type: 'text',
                maxLength: 40,
              },
              {
                label: 'State',
                mapTo: 'jobs[0].state',
                type: 'text',
                maxLength: 2,
              },
              {
                label: 'Zip Code',
                mapTo: 'jobs[0].zipCode',
                type: 'text',
                maxLength: 10,
              },
            ],
          },
          {
            cols: [
              {
                label: 'Employer/Business Name',
                type: 'text',
                mapTo: 'jobs[1].businessName',
                maxLength: 50,
              },
              {
                label: 'Job Title',
                type: 'text',
                mapTo: 'jobs[1].jobTitle',
              },
            ],
          },
          {
            cols: [
              {
                label: 'Start Date',
                mapTo: 'jobs[1].startDate',
                type: 'date',
              },
              {
                label: 'End Date',
                mapTo: 'jobs[1].endDate',
                type: 'date',
              },
              {
                label: '# of hrs. worked per week',
                mapTo: 'jobs[1].hoursByWeek',
                type: 'number',
                min: '0',
                max: '336',
                isInteger: true
              },
              {
                label: 'Rate of Pay',
                type: 'number',
                mapTo: 'jobs[1].rateOfPay',
                min: '0.00',
                max: '100000',
                isDecimal: true
              },
            ],
          },
          {
            cols: [
              {
                label: 'Job Responsibilities',
                type: 'textarea',
                mapTo: 'jobs[1].jobResponsibilities',
                style: {
                  width: '434px',
                },
              },
              {
                label: 'Why did you leave?',
                type: 'textarea',
                mapTo: 'jobs[1].leaveReason',
                style: {
                  width: '434px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'jobs[1].address',
                type: 'text',
              },
              {
                label: 'City',
                mapTo: 'jobs[1].city',
                type: 'text',
                maxLength: 40,
              },
              {
                label: 'State',
                mapTo: 'jobs[1].state',
                type: 'text',
                maxLength: 2,
              },
              {
                label: 'Zip Code',
                mapTo: 'jobs[1].zipCode',
                type: 'text',
                maxLength: 10,
              },
            ],
          },
          {
            cols: [
              {
                label: 'Employer/Business Name',
                type: 'text',
                mapTo: 'jobs[2].businessName',
                maxLength: 50,
              },
              {
                label: 'Job Title',
                type: 'text',
                mapTo: 'jobs[2].jobTitle',
              },
            ],
          },
          {
            cols: [
              {
                label: 'Start Date',
                mapTo: 'jobs[2].startDate',
                type: 'date',
              },
              {
                label: 'End Date',
                mapTo: 'jobs[2].endDate',
                type: 'date',
              },
              {
                label: '# of hrs. worked per week',
                mapTo: 'jobs[2].hoursByWeek',
                type: 'number',
                min: '0',
                max: '336',
                isInteger: true
              },
              {
                label: 'Rate of Pay',
                type: 'number',
                mapTo: 'jobs[2].rateOfPay',
                min: '0.00',
                max: '100000',
                isDecimal: true
              },
            ],
          },
          {
            cols: [
              {
                label: 'Job Responsibilities',
                type: 'textarea',
                mapTo: 'jobs[2].jobResponsibilities',
                style: {
                  width: '434px',
                },
              },
              {
                label: 'Why did you leave?',
                type: 'textarea',
                mapTo: 'jobs[2].leaveReason',
                style: {
                  width: '434px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'jobs[2].address',
                type: 'text',
              },
              {
                label: 'City',
                mapTo: 'jobs[2].city',
                type: 'text',
                maxLength: 40,
              },
              {
                label: 'State',
                mapTo: 'jobs[2].state',
                type: 'text',
                maxLength: 2,
              },
              {
                label: 'Zip Code',
                mapTo: 'jobs[2].zipCode',
                type: 'text',
                maxLength: 10,
              },
            ],
          },
        ],
      },

      {
        style: {
          marginTop: '15px',
        },
        rows: [
          {
            cols: [
              {
                label:
                  'Please answer the following questions about the individual’s interests and preferences.',
                type: 'label',
              },
            ],
          },
          {
            cols: [
              {
                label: 'Preferred days and hours for services:',
                mapTo: 'preferredDaysHoursForServices',
                type: 'text',
              },
              {
                label: 'Preferred method of transportation',
                mapTo: 'preferredTransportationMethod',
                type: 'text',
                maxLength: 50,
              },
            ],
          },
          {
            cols: [
              {
                label:
                  'Tell us more (interests, special skills, biggest challenges, hobbies, etc.)',
                mapTo: 'interests',
                type: 'textarea',
                style: {
                  width: '434px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label:
                  'Access to any of the following technology? (Check all that apply)',
                mapTo: 'options',
                type: 'checkbox',
                optionType: 'AccessToTechnology',
                includeOther: true,
                otherMapTo: 'accessToTechnologyOther',
                maxLength: 300,
                inline: true
              },
            ],
          },
          {
            cols: [
              {
                label:
                  'Explain this individual’s competency with the technology checked above',
                mapTo: 'accessToTechnologyCompetency',
                type: 'textarea',
                style: {
                  width: '434px',
                },
              },
            ],
          },
        ],
      },
      
      
      {
        style: {
          marginTop: '15px',
        },
        rows: [
          {
            cols: [
              {
                label: 'Individual Functional and Exposure Risk Assessment',
                mapTo: 'riskLevel',
                required: false,
                type: 'radio',
                options: riskLevelModel().riskLevel
              }
            ]
          },
          {
            cols: [
              {
                label: 'Should receive communicable and infectious disease training including bloodborne diseases and PPE.',
                mapTo: 'shouldReceiveCommunicableDiseaseTraining',
                required: false,
                type: 'radio',
                options: yesNoModel().yesNo,
                inline: true
              }
            ]
          },
          {
            cols: [
              {
                label: 'The functional limitations checked will be addressed in the planned program for this individual (min. of 3)',
                mapTo: 'options',
                required: false,
                type: 'checkbox',
                optionType: 'FunctionalArea',
                inline: true
              }
            ]
          }
        ]
      },
      {
        style: {
          marginTop: '15px',
        },
        title: 'Document Upload',
        rows: [
          {
            cols: [
              {
                type: 'documentUpload',
              },
            ],
          },
        ],
      }



    ],
  };
};

export default aditionalInformationModel;
